import {
  createAndValidateOrder,
  createAndValidateNautaOrder,
  submitOrder,
  createAndValidatePrebooking,
  submitPrebookingOrder,
  getOrderState as getOrderStateFromAPI,
  getOrders as getOrdersFromAPI,
  submit3DSecureData as submit3DSecureDataAtAPI,
  fetchTopupSubscriptionsByFilter as fetchTopupSubscriptionsByFilterFromAPI,
  createAndValidateSubscription,
  submitRecurringSubscription,
  useCreditBalance,
  removeCreditBalance
} from '@/api/marketplace'
import { calculateOrder,
  checkoutOrderV4 as checkoutLegacyOrderV4,
  fetchOrder as fetchLegacyOrder,
  getPaymentMethodsV4 as getPaymentMethodsFromAPI,
  setPaymentData as submit3DSecureDataLegacyAtAPI
} from '@/api/order'
import { hasToExecute3DSecure, execute3DSecure } from '@/utils/adyen'
import { convertLegacyOrderState } from '@/utils/legacyOrderPaymentStatus'
import { Translation } from '@/utils/Translation'
import { EventBus } from '@/utils/eventBus'
import { getCallingCategoryStringForMParticle, getCallingSubCategoryStringForMParticle } from '@/utils/checkout'
import {
  fetchProductById as fetchProductByIdFromSalesApi
} from '@/api/sales'

const handleError = async ({ commit }, result, type) => {
  // AxiosError
  if (result.code && result.code === 'ERR_NETWORK') {
    commit('SET_ORDER_RESPONSE_ERROR', { type: 'NETWORK_ERROR', message: Translation.t('errors.network') })
  // Asumes its a GraphQL error or REST API provided result.message
  } else {
    commit('SET_ORDER_RESPONSE_ERROR', { type: result.type, result: result })
  }
}
const handleGraphqlError = async ({ commit }, result) => {
  if (result.code && result.code === 'ERR_NETWORK') {
    commit('SET_ORDER_RESPONSE_ERROR', { type: 'NETWORK_ERROR', message: Translation.t('errors.network') })
  } else {
    commit('SET_GRAPHQL_RESPONSE_ERROR', { type: result.code, result: result })
  }
}

/*
  Gets the payment methods avalible and saved cards
*/
const getPaymentMethodsLegacy = async ({ commit, state, dispatch }) => {
  commit('GET_SAVED_PAYMENT_METHODS')
  try {
    const response = await getPaymentMethodsFromAPI() // Legacy REST API call
    if (!response.errors) {
      commit('SET_SAVED_PAYMENT_METHODS_LEGACY', response.savedCreditCards)
      commit('SET_PAYMENT_METHODS_LEGACY', response.paymentMethods)
      commit('SET_SELECTED_PAYMENT_METHOD', response.preferredPaymentInfoId)
    } else {
      throw response.errors
    }
  } catch (result) {
    result.type = 'PAYMENT_METHODS'
    dispatch('handleError', result)
    throw result
  }
}

/*
  Gets the orders in progress - used for Account Activity
*/
const getOrdersInProgress = async ({ commit }) => {
  // commit('GET_SAVED_PAYMENT_METHODS')

  try {
    const response = await getOrdersFromAPI()
    if (!response.errors) {
      commit('SET_ORDERS_IN_PROGRESS', response.data.orders.search)
    } else {
      throw response.errors
    }
  } catch (error) {
    throw error
  }
}

const paymentDataIsLoading = async ({ commit }) => {
  commit('SET_PAYMENT_DATA_LOADING')
}

const paymentDataLoaded = async ({ commit }) => {
  commit('SET_PAYMENT_DATA_LOADED')
}
const setPrebookingPaymentInfo = async ({ commit }, data) => {
  commit('SET_PREBOOK_PAYMENT_INFO', data)
}

const createPrebooking = async ({ commit, state, dispatch }, data) => {
  commit('VALIDATE_ORDER')
  try {
    const response = await createAndValidatePrebooking(data)
    console.log('response', response)
    if (!response.errors) {
      if (response.data && response.data.subscriptions && response.data.subscriptions.createAndValidatePreBooking) {
        commit('SET_PREBOOK_INFO', {...data, executeAt: data.prebookingInfo.executeAt, prebookingId: response.data.subscriptions.createAndValidatePreBooking.id, displayValue: response.data.subscriptions.createAndValidatePreBooking.preBooking.product.value.formatted})
        commit('SET_PREBOOKING', response.data.subscriptions.createAndValidatePreBooking.preBooking)
        if (response.data.subscriptions.createAndValidatePreBooking.preBooking && response.data.subscriptions.createAndValidatePreBooking.preBooking.paymentOptions) {
          const paymentOptions = response.data.subscriptions.createAndValidatePreBooking.preBooking.paymentOptions
          const savedPaymentMethods = paymentOptions.savedMethods
          const availableMethods = []
          for (const method of savedPaymentMethods) {
            if (method.isAvailable) {
              availableMethods.push(method)
              if (!state.selectedPaymentMethod) {
                commit('SET_SELECTED_PAYMENT_METHOD', method.id)
              }
            }
          }
          commit('SET_SAVED_PAYMENT_METHODS', availableMethods)
        }
      }
    } else {
      throw response.errors
    }
  } catch (error) {
    commit('REMOVE_ORDER_INFO')
    dispatch('handleGraphqlError', error)
    throw error
  }
}
/*
This one checks the product and the user if they eligible for making a new subscription.
*/
const fetchTopupSubscriptionsByFilter = async ({ commit, state, dispatch }, data) => {
  try {
    const response = await fetchTopupSubscriptionsByFilterFromAPI({...data}) // If the order (and the user's previous subscriptions) available for making new subscription
    if (!response.errors) {
      if (response.data.subscriptions.search) {
        commit('SET_USERS_SUBSCRIPTION', response.data.subscriptions.search)
      }
      commit('SET_SUBSCRIPTION_FREQUENCY_OPTIONS', data.frequencyOptions)
      commit('SET_SUBSCRIPTION_DATA_LOADED')
    } else {
      throw response.errors
    }
  } catch (result) {
    // I don't want to show any error message or/and cut the flow for subscription!
  }
}
const createAndConfirmTopUpSubscription = async ({ commit, rootState, dispatch }, data) => {
  try {
    // throw new Error('Test error!')
    const response = await createAndValidateSubscription({...data})
    if (!response.errors) {
      console.log('response:', response)
      if (response.data && response.data.subscriptions && response.data.subscriptions.createAndValidateCyclicSubscription) {
        const createdSubs = response.data.subscriptions.createAndValidateCyclicSubscription
        commit('SET_SUBSCRIPTION_DATE', createdSubs)
        commit('SET_CREATED_SUBSCRIPTION_FREQUENCY', createdSubs)
        commit('SET_SUBSCRIPTION_ID', createdSubs)
        let methodId = rootState.checkoutV2.order.savedMethodIdForSubscription // If already existed saved method used for the order, it will not be null
        // If the user added a new payment method for order,
        if (!methodId) {
          methodId = rootState.checkoutV2.lastUsedPaymentMethodId
        }
        // Fallback of adding new card - I need to get the last item of the payment method list, there is no other connection:
        if (!methodId && createdSubs.subscription && createdSubs.subscription.paymentOptions && createdSubs.subscription.paymentOptions.savedMethods && createdSubs.subscription.paymentOptions.savedMethods.length > 0) {
          const savedMethodList = createdSubs.subscription.paymentOptions.savedMethods
          if (savedMethodList.length === 1) {
            methodId = savedMethodList[0].id
          }
          if (savedMethodList.length > 1) {
            const activeSavedMethods = savedMethodList.filter(x => x.isAvailable)
            const sortedActiveSavedMethods = activeSavedMethods.sort((x, y) => x.lastUsedAt - y.lastUsedAt)
            methodId = sortedActiveSavedMethods[0].id
          }
        }
        const params = {
          savedMethodId: methodId,
          sessionData: data.paymentData.sessionData,
          sessionDataId: data.paymentData.sessionDataId,
          subscriptionId: createdSubs.id
        }
        const confirmSubscriptionResponse = await submitRecurringSubscription(params)
        if (!confirmSubscriptionResponse.errors) {
          commit('SET_SUBSCRIPTION_STATE', 'COMPLETED')
        } else {
          // TODO: cancel subscription here!!!! there is no BE support yet.
          console.log('Error on subscription confirming step!!')
          throw response.errors
        }
      }
    } else {
      throw response.errors
    }
  } catch (error) {
    // We have different error handling for different versions of auto top up flow
    commit('SET_SUBSCRIPTION_STATE', 'FAILED')
    throw error
  }
}

/*
 This creates an order, that are needed before being able to submit a payment.
*/
const createOrder = async ({ commit, state, dispatch }, data) => {
  commit('VALIDATE_ORDER')
  if (state.prebookingInfo) { // clean up for normal purchase after pre-booking flow
    commit('SET_PREBOOK_INFO', null)
    commit('SET_PREBOOK_PAYMENT_INFO', null)
  }
  try {
    const response = await createAndValidateOrder(data.msisdn, data.id)
    if (!response.errors) {
      commit('SET_ORDER', response)
      if (response.data && response.data.orders.createAndValidateOrder.order.paymentOptions) {
        const paymentOptions = response.data.orders.createAndValidateOrder.order.paymentOptions
        const savedPaymentMethods = paymentOptions.savedMethods
        const availableMethods = []
        for (const method of savedPaymentMethods) {
          if (method.isAvailable) {
            availableMethods.push(method)
            if (!state.selectedPaymentMethod) {
              commit('SET_SELECTED_PAYMENT_METHOD', method.id)
            }
          }
        }
        commit('SET_SAVED_PAYMENT_METHODS', availableMethods)
      }
      // Auto Subscription flow start below :
      commit('RESET_SUBSCRIPTION') // clean up
      if (response.data && response.data.orders.createAndValidateOrder.order.items && response.data.orders.createAndValidateOrder.order.items.length > 0 &&
              response.data.orders.createAndValidateOrder.order.items[0].product && response.data.orders.createAndValidateOrder.order.items[0].product.subscriptionAvailability) {
        commit('SET_PRODUCT_IS_AVAILABLE_FOR_SUBSCRIPTION')
        const destinationFromOrder = response.data.orders.createAndValidateOrder.order.items[0].destination ? response.data.orders.createAndValidateOrder.order.items[0].destination : {msisdn: null}
        const frequencyOptions = response.data.orders.createAndValidateOrder.order.items[0].product.frequencies
        dispatch('fetchTopupSubscriptionsByFilter', { destination: { msisdn: destinationFromOrder.msisdn, type: 'MSISDN' }, productId: data.id, frequencyOptions })
      }
    } else {
      throw response
    }
  } catch (result) {
    result.type = 'VALIDATE'
    dispatch('handleError', result)
    throw result
  }
}

const createRebtelCreditsOrder = async ({ commit, state, dispatch }, data) => {
  try {
    const freqencyOptions = state.order.subscriptionFrequencyOptions
    const existingSubscriptions = state.order.existedSubscriptionsOfUser
    const response = await useCreditBalance(data)
    if (!response.errors) {
      commit('SET_REBTEL_CREDITS_ORDER', response)
      if (response.data && response.data.orders.useCreditBalance.order.items && response.data.orders.useCreditBalance.order.items.length > 0 &&
        response.data.orders.useCreditBalance.order.items[0].product && response.data.orders.useCreditBalance.order.items[0].product.subscriptionAvailability) {
        commit('SET_PRODUCT_IS_AVAILABLE_FOR_SUBSCRIPTION')
        commit('SET_USERS_SUBSCRIPTION', existingSubscriptions)
        commit('SET_SUBSCRIPTION_FREQUENCY_OPTIONS', freqencyOptions)
      }
    }
  } catch (error) {
    throw error
  }
}

const removeRebtelCreditsOrder = async ({ commit, state }, data) => {
  try {
    const freqencyOptions = state.order.subscriptionFrequencyOptions
    const existingSubscriptions = state.order.existedSubscriptionsOfUser
    const response = await removeCreditBalance(data)
    if (!response.errors) {
      commit('SET_REMOVE_REBTEL_CREDITS_ORDER', response)
      if (response.data && response.data.orders.removeCreditBalance.order.items && response.data.orders.removeCreditBalance.order.items.length > 0 &&
        response.data.orders.removeCreditBalance.order.items[0].product && response.data.orders.removeCreditBalance.order.items[0].product.subscriptionAvailability) {
        commit('SET_PRODUCT_IS_AVAILABLE_FOR_SUBSCRIPTION')
        commit('SET_USERS_SUBSCRIPTION', existingSubscriptions)
        commit('SET_SUBSCRIPTION_FREQUENCY_OPTIONS', freqencyOptions)
      }
    }
  } catch (error) {
    throw error
  }
}

const createNautaOrder = async ({ commit, state, dispatch }, data) => {
  commit('VALIDATE_ORDER')
  if (state.prebookingInfo) { // clean up for normal purchase after pre-booking flow
    commit('SET_PREBOOK_INFO', null)
    commit('SET_PREBOOK_PAYMENT_INFO', null)
  }
  try {
    await new Promise(resolve => setTimeout(resolve, 5000))
    const response = await createAndValidateNautaOrder(data.email, data.id)
    if (!response.errors) {
      commit('SET_ORDER', response)
      if (response.data && response.data.orders.createAndValidateOrder.order.paymentOptions) {
        const paymentOptions = response.data.orders.createAndValidateOrder.order.paymentOptions
        const savedPaymentMethods = paymentOptions.savedMethods
        if (savedPaymentMethods.length > 0) {
          const availableSavedPaymentMethods = savedPaymentMethods.filter(method => method.isAvailable === true)
          if (availableSavedPaymentMethods.length > 0) {
            commit('SET_SELECTED_PAYMENT_METHOD', availableSavedPaymentMethods[0].id)
          } // Need to double check this...
        }
        commit('SET_SAVED_PAYMENT_METHODS', savedPaymentMethods)
      }
    } else {
      throw response
    }
  } catch (result) {
    result.type = 'VALIDATE'
    dispatch('handleError', result)
    throw result
  }
}

/*
 This creates an LEGACY order, that are needed before being able to submit a payment.
 NOTE: This is used for Subscriptions (Calling) and Credits
*/
const createLegacyOrder = async ({ commit, rootState, dispatch }, data) => {
  commit('RESET_SUBSCRIPTION')
  commit('VALIDATE_ORDER')
  if (rootState.checkoutV2.prebookingInfo) { // clean up for normal purchase after pre-booking flow
    commit('SET_PREBOOK_INFO', null)
    commit('SET_PREBOOK_PAYMENT_INFO', null)
  }
  try {
    let product = {
      id: null,
      items: [{ itemId: data.id, type: 'product' }]
    }
    let localeInfo = ['en-US']
    if (rootState && rootState.user && rootState.user.locales) {
      localeInfo = rootState.user.locales[0]
    }
    const response = await calculateOrder(product, rootState.user.currency, localeInfo)
    if (!response.errors) {
      // if there is a message in the legacy response, it is because the Welcome Offer product was swapped for a different one, we need to notify the user of this
      if (response.message) {
        // check if we got World Credits as replacement product and change order type to match
        if (response.items && response.items[0] && response.items[0].name === 'World Credits') {
          commit('SET_ORDER_TYPE', 'worldCredit')
        }
        commit('SET_WELCOME_OFFER_ERROR_MESSAGE', response.message)
      }
      commit('SET_LEGACY_ORDER', response)
      if (response.status && response.status.state === 'failed') {
        commit('SET_ORDER_RESPONSE_ERROR', { type: 'ORDER_CALCULATE', message: response.message })
      }
    } else {
      throw response.errors
    }
  } catch (result) {
    result.type = 'VALIDATE'
    dispatch('handleError', result)
    throw result
  }
}

const setSelectedPaymentMethod = ({ commit }, id) => {
  commit('SET_SELECTED_PAYMENT_METHOD', id)
}

const setOrderType = ({ commit }, filter) => {
  commit('SET_ORDER_TYPE', filter)
}
const confirmPrebookingOrder = async ({commit, rootState, state, dispatch}, data) => {
  commit('SUBMIT_ORDER')
  const params = {
    savedMethodId: rootState.checkoutV2.selectedPaymentMethod ? rootState.checkoutV2.selectedPaymentMethod : rootState.user.wallet.recurringDetailId,
    sessionData: data.sessionData,
    sessionDataId: data.sessionDataId,
    preBookingId: rootState.checkoutV2.prebookingInfo.prebookingId
  }
  try {
    const response = await submitPrebookingOrder(params)
    if (!response.errors) {
      if (response.data && response.data.subscriptions && response.data.subscriptions.submitRecurringPreBooking) {
        commit('SET_ORDER_STATE', 'COMPLETED')
      }
    } else {
      throw response.errors
    }
  } catch (result) {
    result.type = 'SUBMIT'
    console.log('result', result)
    dispatch('handleGraphqlError', result)
    throw result
  }
}
/*
 When the user checkout the order.
*/
const confirmOrder = async ({ commit, state, dispatch }, data) => {
  commit('SUBMIT_ORDER')
  const recurringMethod = data.recurringPayment
  // When we have a subscription flow, I need to keep the recurringMethod info if it's existed to use later to complete the subscription
  if (state.order.isProductAvailableForSubscription && state.order.existedSubscriptionsOfUser && state.order.existedSubscriptionsOfUser.length === 0) {
    const methodIdForSubscription = recurringMethod ? state.selectedPaymentMethod : false
    commit('SET_PAYMENT_METHOD_ID_FOR_SUBSCRIPTION', methodIdForSubscription)
  }
  try {
    const response = await submitOrder({
      ...data,
      savedMethodId: recurringMethod ? state.selectedPaymentMethod : false,
      orderId: state.order.id
    })
    if (!response.errors) {
      commit('ORDER_SUBMIT_RESPONSE_SUCCESS', response)
      dispatch('getOrderState', state.order.id)
      // This is only needed as long as we still have the old 3DS implementation. The new 3DS implementation will only return a result for 3DS @ getOrderState
      // const order = recurringMethod ? response.data.orders.submitOrderRecurringV2 : response.data.orders.submitOrderV2
      // if (order.providerData) {
      //   let providerData = JSON.parse(order.providerData)
      //   commit('SET_ORDER_STATE', '3D_SECURITY_CHECK_LEGACY')
      //   execute3DSecure(providerData)
      // } else {
      //   dispatch('getOrderState', state.order.id)
      // }
    } else {
      throw response.errors
    }
  } catch (result) {
    result.type = 'SUBMIT'
    dispatch('handleError', result)
    throw result
  }
}

/*
 When the user checkout the order.
*/
const submit3DSecureDataLegacy = async ({ commit, state, dispatch }, providerData) => {
  commit('SUBMIT_3D_SECURE_DATA')
  try {
    const response = await submit3DSecureDataLegacyAtAPI({
      providerData: providerData,
      orderId: state.order.id
    })
    if (!response.errors) {
      dispatch('getOrderState', state.order.id)
    } else {
      throw response.errors
    }
  } catch (result) {
    result.type = 'SUBMIT_3D_SECURE_DATA'
    dispatch('handleError', result)
    throw result
  }
}

const submit3DSecureData = async ({ commit, state, dispatch }, providerData) => {
  commit('SUBMIT_3D_SECURE_DATA')
  try {
    const response = await submit3DSecureDataAtAPI({
      providerData: providerData,
      orderId: state.order.id
    })
    if (!response.errors) {
      dispatch('getOrderState', state.order.id)
    } else {
      throw response.errors
    }
  } catch (result) {
    result.type = 'SUBMIT_3D_SECURE_DATA'
    dispatch('handleError', result)
    throw result
  }
}

const setAutoPurchase = ({ commit }, value) => {
  commit('SET_AUTO_PURCHASE', value)
}

/*
 When the user checkout the order. - Confirms a legacy order
*/
const confirmLegacyOrder = async ({ commit, state, dispatch, getters }, data) => {
  commit('SUBMIT_ORDER')

  // dispatch('handleError', Error('error1'))
  if (data.recurringPayment) {
    let selectedPaymentMethod = getters.getSelectedCardLegacy

    if (!selectedPaymentMethod) { // Not sure if this is needed
      selectedPaymentMethod = getters.getPrimaryCard
    }
    delete data.recurringPayment
    data.payment = {
      ...data.payment,
      paymentSource: 'ManualSaved',
      provider: { id: selectedPaymentMethod.providerId },
      method: { id: selectedPaymentMethod.method },
      paymentInfoId: selectedPaymentMethod.paymentInfoId
    }
  }

  let offeredAsSubscription = false
  if (state.order.items && state.order.items[0] && state.order.items[0].itemId) {
    const productId = state.order.items[0].itemId
    const productResponseFromSalesAPI = await fetchProductByIdFromSalesApi(productId)
    offeredAsSubscription = (productResponseFromSalesAPI && productResponseFromSalesAPI.offeredAsSubscription) ? productResponseFromSalesAPI.offeredAsSubscription : false
  }
  data.payment.enableAutoPurchase = state.autoPurchase ? state.autoPurchase && offeredAsSubscription : offeredAsSubscription
  try {
    const response = await checkoutLegacyOrderV4({
      ...data
    })

    if (response.status && response.status.state === 'pending') { // TODO REST API MIGHT RETURN A DIFFERENT ERROR MESSAGE, OR NONE AT ALL!
      commit('LEGACY_ORDER_SUBMIT_RESPONSE_SUCCESS', response)

      if (hasToExecute3DSecure(response.payment.providerData)) {
        let providerData = JSON.parse(response.payment.providerData)

        // commit('SET_3D_SECURE_CHALLANGE', providerData)
        commit('SET_ORDER_STATE', '3D_SECURITY_CHECK_LEGACY')
        execute3DSecure(providerData)
      } else {
        dispatch('getOrderState', response.id)
      }
    } else if (response.status && response.status.state === 'success') {
      dispatch('getOrderState', response.id)
    } else {
      throw response
    }
  } catch (result) {
    result.type = 'SUBMIT'
    dispatch('handleError', result)
    throw result
  }
}

/*
  When the user clicks Add New Payment although it has saved payment methods.
*/
const addNewPaymentMethod = async ({ commit }) => {
  commit('ADD_NEW_PAYMENT_METHOD')
}

const viewSavedPaymentMethods = async ({ commit }) => {
  commit('VIEW_SAVED_PAYMENT_METHOD')
}

/*
  After a order is submitted, this funciton is called to check the order state and if the payment is completed
*/
const getOrderState = async ({ commit, rootState, state, dispatch }, orderId) => {
  commit('ORDER_STATE_CHECK_COUNTER_INCREASE')
  try {
    let order, orderState, savedMethodId
    if (state.order.legacy) {
      order = await fetchLegacyOrder(orderId)
      orderState = convertLegacyOrderState(order.status.state)
    } else {
      const response = await getOrderStateFromAPI(orderId)
      if (response.errors) {
        throw response.errors
      }
      order = response.data.orders.search[0]
      if (order) {
        orderState = order.state
        savedMethodId = order.payment.savedMethodId
      } else {
        throw Error('No order found')
      }
    }

    commit('SET_ORDER_STATE', orderState)
    if (order.payment && order.payment.providerData) {
      let providerData = JSON.parse(order.payment.providerData)

      if (providerData.sdk) {
        commit('SET_ORDER_STATE', '3D_SECURITY_CHECK')
        commit('SET_3D_SECURE_CHALLANGE', providerData)
      } else { // TODO: Else case might be unnecessary. Remove it later.
        commit('SET_ORDER_STATE', '3D_SECURITY_CHECK_LEGACY')
        execute3DSecure(providerData)
      }
    } else if (orderState === 'IN_PROGRESS') {
      if (state.orderStateChecks < 10) {
        await new Promise(resolve => setTimeout(resolve, 3000))
        dispatch('getOrderState', orderId)
      } else {
        commit('SET_ORDER_STATE', 'PENDING')
      }
    } else if (state.orderState === 'FAILED') {
      if (state.order.legacy) {
        commit('SET_ORDER_RESPONSE_ERROR', { type: 'CHECK_ORDER_STATE', message: order.message })
      }
    } else if (orderState === 'COMPLETED') {
      commit('SET_LAST_USED_PAYMENT_METHOD_ID', savedMethodId)
      // 2. Summarize the transaction
      if (state.orderType === 'calling' || state.orderType === 'callingDeal') {
        EventBus.emitBalanceChangedEvent()
      }

      // If paymentCount isn't set we need to load it
      if (rootState.user.paymentCount === null) {
        await dispatch('user/getUserPaymentCount', null, {root: true})
      }

      // 3. Log the purchase event (optional custom attributes an custom flags depending on your );
      try {
        // push purchase event to GTM data layer as well WEB-401
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'purchase',
            attributes: {
              transaction_id: state.order.id,
              currency: state.order.legacy ? state.order.totalAmount.currencyId : state.order.summary.netAmount.currency,
              value: state.order.legacy ? state.order.totalAmount.amount : state.order.summary.total.amount,
              tax: state.order.legacy ? (state.order.totalVatAmount ? state.order.totalVatAmount.amount : 0) : state.order.summary.vats[0].vatAmount.amount,
              service_category: state.order.legacy ? 'Calling' : state.order.items[0].product.serviceCategory,
              product_category: state.order.legacy ? getCallingCategoryStringForMParticle(state.order.items[0]) : state.order.items[0].product.productCategory,
              product_sub_category: state.order.legacy ? getCallingSubCategoryStringForMParticle(state.order.items[0]) : state.order.items[0].product.productSubCategory,
              destination_country: state.order.legacy ? null : state.order.items[0].product.countryId,
              is_new_paying_user: !rootState.user.paymentCount || rootState.user.paymentCount <= 1,
              items: state.order.legacy
                ? [{ item_id: state.order.items[0].itemId, item_name: state.order.items[0].name }]
                : [{ item_id: state.order.items[0].productId, item_name: state.order.items[0].product.title }]
            }
          })
        }
      } catch (error) {
        // I do not want to take an action here
      }
    }
  } catch (result) {
    result.type = 'CHECK_ORDER_STATE'
    dispatch('handleError', result)
    throw result
  }
}

const setOrderState = ({ commit }, state) => {
  commit('SET_ORDER_STATE', state)
}

const setOrderError = ({ commit }, state) => {
  commit('SET_ORDER_ERROR', state)
}
const preSelectSubscriptionFrequency = ({ commit }, data) => {
  commit('PRESET_SUBSCRIPTION_FREQUENCY', data)
}

export default {
  getPaymentMethodsLegacy,
  handleError,
  createOrder,
  createLegacyOrder,
  paymentDataLoaded,
  paymentDataIsLoading,
  confirmOrder,
  confirmLegacyOrder,
  submit3DSecureData,
  submit3DSecureDataLegacy,
  getOrderState,
  setOrderState,
  setOrderError,
  setOrderType,
  setAutoPurchase,
  setSelectedPaymentMethod,
  addNewPaymentMethod,
  viewSavedPaymentMethods,
  getOrdersInProgress,
  createNautaOrder,
  confirmPrebookingOrder,
  handleGraphqlError,
  setPrebookingPaymentInfo,
  createPrebooking,
  fetchTopupSubscriptionsByFilter,
  createAndConfirmTopUpSubscription,
  preSelectSubscriptionFrequency,
  createRebtelCreditsOrder,
  removeRebtelCreditsOrder
}



// WEBPACK FOOTER //
// ./src/store/modules/checkout-v2/actions.js